import React, { useEffect, useState } from 'react';
import { AutocompleteV, Icons } from 'components';
import { useFormContext } from 'react-hook-form';
import transactionService from './services';

const FIELD_NAME = 'ReasonForTransaction';

const MANAGE_LIQUIDITY_OPTION = {
  id: 'DETAIL_TYPE_MANAGE_LIQUIDITY',
  label: 'مدیریت نقدینگی',
  value: 'DETAIL_TYPE_MANAGE_LIQUIDITY',
  name: 'مدیریت نقدینگی',
};

const ReasonForTransaction = ({ disabled = false }) => {
  const {
    control,
    formState: { errors },
    register,
    unregister,
    setValue,
  } = useFormContext();

  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);

  /**
   * ثبت فیلد و تعیین مقدار اولیه
   */
  useEffect(() => {
    register(FIELD_NAME);

    setValue(FIELD_NAME, null, {
      shouldValidate: false,
      shouldDirty: false,
      shouldTouch: false,
    });

    return () => {
      unregister(FIELD_NAME);
    };
  }, [register, setValue, unregister]);

  /**
   * تنظیم مقدار فیلد براساس disabled
   */
  useEffect(() => {
    setValue(
      FIELD_NAME,
      disabled ? MANAGE_LIQUIDITY_OPTION : null,
      {
        shouldValidate: false,
        shouldDirty: false,
        shouldTouch: false,
      },
    );
  }, [disabled, setValue]);

  /**
   * دریافت گزینه‌ها از سرور
   */
  useEffect(() => {
    let isMounted = true;

    const getDetailTransaction = async () => {
      setLoading(true);

      try {
        const result = await transactionService.getForTransaction();
        const data = result?.result ?? [];

        const options = data.map((item) => ({
          id: item?.key,
          label: String(item?.value ?? ''),
          value: item?.key,
          name: String(item?.value ?? ''),
        }));

        if (isMounted) {
          setList(options);
        }
      } catch (error) {
        console.log('error:', error);
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    getDetailTransaction();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <AutocompleteV
      control={control}
      errors={errors}
      register={register}
      name={FIELD_NAME}
      placeholder="جستجو و انتخاب کنید..."
      label="بابت"
      rules={['required']}
      disabled={disabled}
      preventAddCustomOption
      style={{
        backgroundColor: disabled
          ? 'rgb(241 241 241)'
          : undefined,
      }}
      list={list}
      disableClearable
      loading={loading}
    />
  );
};

export default ReasonForTransaction;
